import React from 'react'
import injectSheet from 'react-jss'
import uuid from 'uuid'

import styles from './add-teacher.styles.js'

import Button from 'pobble-components/dist/button'
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter
} from 'pobble-components/dist/modal'
import FormInput from 'pobble-components/dist/form-elements/form-input'

import { Formik } from 'formik'
import * as Yup from 'yup'

const AddTeacher = ({ classes, onSubmit, isOpen, onClose }) => (
  <Modal legacy isOpen={isOpen}>
    <ModalHeader>Add a teacher</ModalHeader>
    <Formik
      initialValues={{
        id: uuid(),
        email: ''
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .required('Please provide an email address')
          .email('Please provide a correct email address')
      })}
      onSubmit={({ id, email }) => onSubmit({ id, email }) && onClose()}>
      {props => {
        const {
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          errors,
          isValid,
          touched
        } = props
        return (
          <form onSubmit={handleSubmit}>
            <ModalContent>
              <FormInput type="hidden" name="id" title="id" value={values.id} />
              <label htmlFor="email" className={classes.label}>
                Email address <sup className={classes.sup}>*</sup>
              </label>
              <FormInput
                name="email"
                id="email"
                placeholder="Ex: teacher@school.com"
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                validationError={touched.email && errors.email}
                className={classes.input}
              />
            </ModalContent>
            <ModalFooter className={classes.footer}>
              <Button simple action={onClose}>
                Cancel
              </Button>
              <Button type="submit" disabled={!isValid}>
                Add
              </Button>
            </ModalFooter>
          </form>
        )
      }}
    </Formik>
  </Modal>
)

export default injectSheet(styles)(AddTeacher)
